export type ConfidenceRating = 'High' | 'Medium' | 'Low';

// Single source of truth for confidence % -> rating across the app.
export function getConfidenceRating(level: number): ConfidenceRating {
  if (level >= 85) {
    return 'High';
  }
  if (level >= 70) {
    return 'Medium';
  }
  return 'Low';
}
